import { useEffect, useState } from "react";

export default function CookieConsent({ content, onOpenPrivacy }) {
  const cc = content?.cookie_consent || {};
  const [show, setShow] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookie_consent") === "true";
    if (!accepted) {
      const t = setTimeout(() => setShow(true), 900);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_consent", "true");
    setShow(false);
    // analytics would init here after consent
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[90] p-3 sm:p-4" data-testid="cookie-consent">
      <div className="glass max-w-4xl mx-auto flex flex-col sm:flex-row items-center gap-3 sm:gap-5" style={{ padding: "1rem 1.3rem" }}>
        <p className="text-sm flex-1" style={{ color: "var(--text-sec)" }}>
          {cc.text}{" "}
          <button className="grad-text font-semibold underline" onClick={onOpenPrivacy} data-testid="cookie-privacy-link">
            Политика конфиденциальности
          </button>
        </p>
        <button className="btn-grad px-6 py-2.5 text-sm whitespace-nowrap" onClick={accept} data-testid="cookie-accept-btn">
          {cc.accept_text}
        </button>
      </div>
    </div>
  );
}
